import React from 'react'

/**
 * 나만 보기 기록 표시 — 자물쇠만.
 *
 * 날짜 줄 맨 앞에 놓고 가운뎃점으로 날짜와 잇는다:
 *
 *     🔒 · 2026년 9월 10일            매장 이용
 *
 * 글자("나만 보기")를 함께 두었다가 뺐다. 자물쇠는 뜻이 분명한 기호라
 * 설명이 없어도 읽히고, 날짜 줄은 이미 오른쪽에 이용 형태가 있어 좁다.
 *
 * 크기와 정렬
 * ----------
 * 자물쇠는 15px, 글자는 14px(captionM)이다. 아이콘 도형은 viewBox 안에서
 * y 2.8~21만 차지하므로 실제 잉크 높이는 11.4px로 글자(12.1px)보다 조금 작다.
 * 아이콘이 글자를 압도하지 않으면서 같은 덩어리로 읽히는 크기다.
 *
 * 세로는 align-items:center만 쓰고 따로 밀지 않는다.
 *
 * 14px일 때는 0.5px 올렸었다. 작아서 올려도 글자 안에 머물렀기 때문이다.
 * 15px에서는 같은 값을 주면 자물쇠 윗부분이 글자 윗선(4.45) 위로 튀어나가
 * (4.25) 혼자 떠 보인다. 실측 범위는 이렇다:
 *
 *     글자 잉크        4.45 ~ 16.59
 *     15px 오프셋 0    4.75 ~ 16.12   ← 글자 안
 *     15px 오프셋 -0.5 4.25 ~ 15.62   ← 윗선 밖
 *
 * 크기를 바꾸면 이 계산을 다시 할 것. 올릴수록 좋아지는 값이 아니다.
 */
const PrivateBadge: React.FC = () => (
  <span className="inline-flex items-center">
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      // brandPrimary — rgba(75, 54, 33, 0.8)
      fill="#4B3621"
      fillOpacity="0.8"
      className="flex-shrink-0"
      aria-hidden="true"
    >
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path
        d="M8 11V8a4 4 0 0 1 8 0v3"
        fill="none"
        stroke="#4B3621"
        strokeOpacity="0.8"
        strokeWidth="2.4"
      />
    </svg>
  </span>
)

export default PrivateBadge
